import { render, staticRenderFns } from "./MotionSensor.vue?vue&type=template&id=83a2c2ce&"
import script from "./MotionSensor.vue?vue&type=script&lang=ts&"
export * from "./MotionSensor.vue?vue&type=script&lang=ts&"
import style0 from "./MotionSensor.vue?vue&type=style&index=0&id=83a2c2ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports